/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.04.2016.
 */

import _get from 'lodash/get';

import {ParseResource} from '../../utils';

export const GET_BG_SHOWCASE = 'get-showcase-for-background';
export const GET_BANNERS_SHOWCASE = 'get-showcase-for-banners-under-menu';

const _parseSliderItem = (item) => {
  let sliderItem = {};

  if (item.widget_attrs && item.widget_attrs.asset) {
    sliderItem = {
      text: item.widget_attrs.text || '',
      type: 'asset'
    };

  } else if (item.widget_attrs && item.widget_attrs.url) {
    sliderItem = {
      text: item.widget_attrs.text || '',
      type: 'url'
    };
  }

  let parsedResource = ParseResource(item.picture);

  sliderItem.picture_update_time = parsedResource['update_time'] || '';

  let pictureQ = lh.common.resources
    .getPictureByCategory([
      {
        url: item.picture.split('?')[0],
        resource_group_id: parsedResource['resource_group_id'],
        type: 'picture'
      }
    ], null)
    .then(
      (response) => response,
      () => '');

  var dataQ;
  if (sliderItem.type === 'asset') {

    dataQ = lh.asset
      .getAssets(
        {filters: [lh.models.asset.accessor.extid.eq(item.widget_attrs.asset)]}
      )
      .then(
        (collection) => {
          return collection[0] || {};
        },
        () => {
          return {};
        }
      );
  } else if (sliderItem.type === 'url') {

    dataQ = Promise.resolve(item.widget_attrs.url);
  }

  return Promise.all([dataQ, pictureQ])
    .then((values) => {

      sliderItem[_get(sliderItem, 'type')] = values[0];
      sliderItem.picture = values[1] + '?t=' + _get(sliderItem, 'picture_update_time');

      return sliderItem
    })
    .catch(() => sliderItem);
  //return sliderItem;
};

export function GetBgShowcase(label) {
  let bgLabel = label || _get(Config, 'background_label');

  if (!bgLabel) {

    return {
      type: GET_BG_SHOWCASE,
      payload: Promise.resolve({})
    }
  }

  let Q = lh.showcases.getShowcaseByLabel(bgLabel)
    .then(lh.showcases.getTilesByShowcaseId)
    .then(function (collection = []) {

      let background = {
        id: collection[0].id,
        slider: _get(collection[0], 'banner.slider_items', []).map(_parseSliderItem),
        slider_delay: collection[0].banner.slider_delay || _get(Config, 'background_slider_delay', 10000)
      };

      return Promise.all(background.slider)
        .then((results) => {

          background.slider = results;
          return background;
        })
        .catch((results) => {

          background.slider = results;
          return background;
        });
    });

  return {
    type: GET_BG_SHOWCASE,
    payload: Q
  }
}

export function GetBannersShowcase(label) {
  let bannersLabel = label || _get(Config, 'banners_label');

  if (!bannersLabel) {

    return {
      type: GET_BANNERS_SHOWCASE,
      payload: Promise.resolve({})
    }
  }

  let Q = lh.showcases.getShowcaseByLabel(bannersLabel)
    .then(lh.showcases.getTilesByShowcaseId)
    .then(function (collection = []) {

      let banners = {
        id: collection[0].id,
        slider: _get(collection[0], 'banner.slider_items', []).map(_parseSliderItem),
        slider_delay: collection[0].banner.slider_delay || _get(Config, 'banners_slider_delay', 10000)
      };

      return Promise.all(banners.slider)
        .then((results) => {

          banners.slider = results;
          return banners;
        })
        .catch((results) => {

          banners.slider = results;
          return banners;
        });
    });

  return {
    type: GET_BANNERS_SHOWCASE,
    payload: Q
  }
}



// WEBPACK FOOTER //
// ./src/actions/showcase/actions-showcase.js